import { render, staticRenderFns } from "./MobileProfitAndLoss.vue?vue&type=template&id=fd514666&scoped=true"
import script from "./MobileProfitAndLoss.vue?vue&type=script&lang=js"
export * from "./MobileProfitAndLoss.vue?vue&type=script&lang=js"
import style0 from "./MobileProfitAndLoss.vue?vue&type=style&index=0&id=fd514666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd514666",
  null
  
)

export default component.exports